// extracted by mini-css-extract-plugin
export default {"navigation-bottom-bar-content__button-back":"NavigationBottomBarContent_navigation-bottom-bar-content__button-back__3nzj_"};